var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookJourneySvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 41.837,
    height: 47.814,
    viewBox: "0 0 41.837 47.814",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2592",
    "data-name": "Rect\\xE1ngulo 2592",
    width: 41.837,
    height: 47.814,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6652",
    "data-name": "Grupo 6652",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6651",
    "data-name": "Grupo 6651",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5444",
    "data-name": "Trazado 5444",
    d: "M10.958,47.814H5.977A5.983,5.983,0,0,1,0,41.837V5.978A5.983,5.983,0,0,1,5.977,0h4.981a1,1,0,0,1,1,1V46.818a1,1,0,0,1-1,1M5.977,1.993A3.989,3.989,0,0,0,1.992,5.978v35.86a3.989,3.989,0,0,0,3.985,3.985H9.962V1.993Z",
    transform: "translate(0 0)",
    fill: "#052941"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5445",
    "data-name": "Trazado 5445",
    d: "M48.417,47.814H18.534a1,1,0,0,1-1-1V1a1,1,0,0,1,1-1H48.417a1,1,0,0,1,1,1V46.818a1,1,0,0,1-1,1M19.53,45.822H47.421V1.993H19.53Z",
    transform: "translate(-7.576 0)",
    fill: "#052941"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5446",
    "data-name": "Trazado 5446",
    d: "M47.463,43.76H25.548a1,1,0,0,1-1-1V30.81a1,1,0,0,1,1-1H47.463a1,1,0,0,1,1,1V42.763a1,1,0,0,1-1,1M26.545,41.768H46.467V31.807H26.545Z",
    transform: "translate(-10.606 -12.879)",
    fill: "#052941"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5447",
    "data-name": "Trazado 5447",
    d: "M53.524,68.634H39.578a1,1,0,1,1,0-1.993H53.524a1,1,0,1,1,0,1.993",
    transform: "translate(-16.667 -28.789)",
    fill: "#fc5145"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5448",
    "data-name": "Trazado 5448",
    d: "M57.312,75.65H48.347a1,1,0,0,1,0-1.993h8.965a1,1,0,0,1,0,1.993",
    transform: "translate(-20.455 -31.819)",
    fill: "#fc5145"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5449",
    "data-name": "Trazado 5449",
    d: "M46.508,38.822H32.562a1,1,0,1,1,0-1.993H46.508a1,1,0,1,1,0,1.993",
    transform: "translate(-13.636 -15.91)",
    fill: "#052941"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5450",
    "data-name": "Trazado 5450",
    d: "M46.031,45.837H36.07a1,1,0,0,1,0-1.993h9.961a1,1,0,0,1,0,1.993",
    transform: "translate(-15.152 -18.94)",
    fill: "#052941"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookJourneySvg);
export default __webpack_public_path__ + "static/media/Book-journey-svg.d8cb87d3830f7164a7f3e6f1a0df3204.svg";
export { ForwardRef as ReactComponent };